import { Controller } from "@hotwired/stimulus"

// Controls the "Add Task" form on the claim to-do list.
//
// The form wrapper (data-todo-form-target="form") starts with the `hidden`
// class. The header "Add Task" button (data-todo-form-target="button") toggles
// it. The inner form_with form posts via Turbo Stream
// (action: "submit->todo-form#submit"); the create.turbo_stream.erb response
// replaces #add-todo-form with a fresh, hidden form, which resets + hides it
// server-side. So the submit handler simply lets Turbo proceed while guarding
// against double submits. cancel hides the form and clears the fields.
export default class extends Controller {
  static targets = ["form", "button", "title", "submit"]
  static classes = ["hidden"]

  // The view applies a literal `hidden` class to the form wrapper; allow an
  // optional data-todo-form-hidden-class override, otherwise default to "hidden".
  get hiddenClassName() {
    return this.hasHiddenClass ? this.hiddenClass : "hidden"
  }

  get isHidden() {
    return this.hasFormTarget && this.formTarget.classList.contains(this.hiddenClassName)
  }

  toggle() {
    if (!this.hasFormTarget) return

    if (this.isHidden) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    if (!this.hasFormTarget) return

    this.formTarget.classList.remove(this.hiddenClassName)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }

    if (this.hasTitleTarget) {
      this.titleTarget.focus()
    }
  }

  hide() {
    if (!this.hasFormTarget) return

    this.formTarget.classList.add(this.hiddenClassName)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  // Fires on the inner form's native submit event. Turbo intercepts the submit
  // and sends it as a Turbo Stream request; the server response resets + hides
  // the form, so we only need to prevent a double-submit and give feedback.
  submit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }

  cancel() {
    this.resetForm()
    this.hide()
  }

  resetForm() {
    if (!this.hasFormTarget) return

    const form = this.formTarget.querySelector("form")
    if (form) form.reset()

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed")
    }
  }
}
